module.exports = __webpack_public_path__ + "static/media/14.d02576e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/boulders/14.jpg
// module id = 473
// module chunks = 0